import { Box, FormControl, FormHelperText, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { ReactElement } from 'react'

interface TextAreaInputPropsType {
    id: string
    label: string
    value: string
    onChange: any
    required?: boolean
    placeholder?: string
    disabled?: boolean
    errorMessage?: string
}

const TextAreaInput = (props: TextAreaInputPropsType): ReactElement => {
    const {
        id,
        label,
        value,
        onChange,
        required,
        placeholder,
        disabled,
        errorMessage = '',
    } = props
    const { t } = useTranslation()

    return (
        <Box sx={{ width: '100%' }}>
            <FormControl fullWidth>
                <Typography sx={{ opacity: '0.7', fontSize: '14px' }}>
                    {label}
                    {required ? '*' : ''}
                </Typography>
                <textarea
                    id={id}
                    aria-label={label}
                    style={{
                        width: '100%',
                        maxWidth: '100%',
                        minWidth: '100%',
                        minHeight: '150px',
                        borderRadius: '4px',
                        borderColor:
                            errorMessage !== '' ? 'red' : 'rgb(0 0 0 / 25%)',
                        fontFamily: "'Roboto Condensed', sans-serif",
                        padding: '10px',
                    }}
                    className="field-focus-border-color field-textarea-placeholder"
                    placeholder={
                        placeholder ? placeholder : t('enterLabel', { label })
                    }
                    value={value}
                    onChange={(e) => onChange(id, e.target.value)}
                    disabled={disabled}
                    // onBlur={(e) => onBlurArea(id, e.target.value)}
                ></textarea>
                {errorMessage !== '' && (
                    <FormHelperText sx={{ color: 'red' }}>
                        {errorMessage}
                    </FormHelperText>
                )}
            </FormControl>
        </Box>
    )
}

export default TextAreaInput
